export default __webpack_public_path__ + "static/media/rails.7d7deb52.png";